export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_03_Loop.7d5022d0.mp4";